import { Component } from '@angular/core';

@Component({
    selector: 'app-api-offline-message',
    styleUrls: ['./api-offline-message.component.scss'],
    templateUrl: './api-offline-message.component.html',
})
export class ApiOfflineMessageComponent { }
